/* eslint-disable */
import axios from 'axios'
// import Qs from 'qs'
import store from '@/store/index'
import { Message } from 'element-ui'
const marketID = 28
const marketId = 28;
const Language = 'ZH'
// test
axios.interceptors.request.use(
  (config) => {
    // loading
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    return Promise.resolve(error.response)
  }
)

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response) {
    return response
    // 如果不需要除了data之外的数据，可以直接 return response.data
  }
  // 异常状态下，把错误信息返回去
  // // console.log('status: -404')
  return {
    status: -404,
    code: -404,
    msg: '网络不稳定', // 网络不稳定
    message: '网络不稳定' // 网络不稳定
  }
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.status == -404) {
    // Message({
    //     showClose: true,
    //     message: res.msg,
    //     type: 'error',
    //     duration: 2000
    // })
  }
  if (res.data) {
    if (
      res.data.code == '-10011' ||
      res.data.code == '-2' ||
      res.data.code == '-4'
    ) {
      if (res.data.code == '-2') {
        // Message({
        //   showClose: true,
        //   message: '会话失效请重新登陆',
        //   type: 'error',
        //   duration: 2000
        // })
        store.commit('setSessionInfo', '')
        store.commit('marketStatusInNewTopline', '--')
        sessionStorage.clear()
        console.log('http login')
        global.router.push('/login')
      } else if (res.data.code == '-4') {
        Message({
          showClose: true,
          message: '被他人登录，建议修改密码',
          type: 'error',
          duration: 2000
        })
        store.commit('setSessionInfo', '')
        store.commit('marketStatusInNewTopline', '--')
        sessionStorage.clear()
        console.log('http login')
        global.router.push('/login')
      } else {
        // Message({
        //   showClose: true,
        //   message: '会话失效请重新登陆',
        //   type: 'error',
        //   duration: 2000
        // })
        store.commit('setSessionInfo', '')
        store.commit('marketStatusInNewTopline', '--')
        sessionStorage.clear()
        console.log('http login')
        global.router.push('/login')
        window.location.href='/login';
      }
    }
  }
  return res
}

export default {
  getNewPath2(data) {
    const sessionStr = store.state.common.sessionInfo.sessionStr
    let url = window.g.APP_URL_PATH2 + data.url
    const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    if (data.param) {
      Object.keys(data.param).forEach(function(key, i, v) {
        if (i == 0) {
          url += '/' + data.param[key]
        }
      })
    }
    return axios({
      method: 'get',
      url,
      timeout: window.g.AXIOS_TIMEOUT,
      dataType: 'jsonp',
      cache: 'false',
      crossDomain: true,
      headers: {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        sessionStr: sessionStr,
        firmId: firmId,
        userId: userId,
        marketId: marketID,
        Language: Language,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase()
      },
      withCredentials: false
    })
      .then((response) => {
        return response
      })
      .then((res) => {
        return res
      })
  },
  getNewPath2Market0(data) {
    const sessionStr = store.state.common.sessionInfo.sessionStr
    let url = window.g.APP_URL_PATH2 + data.url
    const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    if (data.param) {
      Object.keys(data.param).forEach(function(key, i, v) {
        if (i == 0) {
          url += '/' + data.param[key]
        }
      })
    }
    return axios({
      method: 'get',
      url,
      timeout: window.g.AXIOS_TIMEOUT,
      dataType: 'jsonp',
      cache: 'false',
      crossDomain: true,
      headers: {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        sessionStr: sessionStr,
        firmId: firmId,
        userId: userId,
        marketId: 0,
        Language: Language,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase()
      },
      withCredentials: false
    })
      .then((response) => {
        return response
      })
      .then((res) => {
        return res
      })
  },
  getRes(data) {
    const userId = store.state.common.sessionInfo.userId
    const options = {
      method: 'get',
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      params: data.param,
      dataType: 'json',
      timeout: window.g.AXIOS_TIMEOUT
    }
    if (store.state.common.sessionInfo.isLogin === 'true') {
      options.headers = {
        firmId: store.state.common.sessionInfo.firmId,
        sessionStr: store.state.common.sessionInfo.sessionStr,
        userId: userId,
        marketId: marketID,
        Language: Language,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4
      }
    } else {
      // delete options.headers
      options.headers = {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4

      }
    }
    return axios(options)
      .then((response) => {
        return checkStatus(response)
      })
      .then((res) => {
        return checkCode(res)
      })
  },
  postFrontChange(data,marketId) {
    const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    // userId='100010';
    return axios({
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      data: data.param,
      dataType: 'json',
      headers: {
        firmId: firmId,
        'User-Id': userId,
        userId: userId,
        marketId: marketId,
        Language: Language,
        sessionStr: sessionStr,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase()
      },
      timeout: window.g.AXIOS_TIMEOUT
    })
      .then((response) => {
        return checkStatus(response)
      })
      .then((res) => {
        return checkCode(res)
      })
  },
  postFront(data) {
    const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    // userId='100010';
    return axios({
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      data: data.param,
      dataType: 'json',
      headers: {
        firmId: firmId,
        'User-Id': userId,
        userId: userId,
        marketId: marketID,
        Language: Language,
        sessionStr: sessionStr,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase()
      },
      timeout: window.g.AXIOS_TIMEOUT
    })
      .then((response) => {
        return checkStatus(response)
      })
      .then((res) => {
        return checkCode(res)
      })
  },
  postFrontMarket0(data) {
    const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    // userId='100010';
    return axios({
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      data: data.param,
      dataType: 'json',
      headers: {
        firmId: firmId,
        'User-Id': userId,
        userId: userId,
        marketId: 0,
        Language: Language,
        sessionStr: sessionStr,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase()
      },
      timeout: window.g.AXIOS_TIMEOUT
    })
      .then((response) => {
        return checkStatus(response)
      })
      .then((res) => {
        return checkCode(res)
      })
  },
  postBankM0(data) {
    const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    // userId='100010';
    return axios({
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      data: data.param,
      dataType: 'json',
      headers: {
        firmId: firmId,
        'User-Id': userId,
        userId: userId,
        marketId: 0,
        Language: Language,
        sessionStr: sessionStr,
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase()
      },
      timeout: 30000
    })
      .then((response) => {
        return checkStatus(response)
      })
      .then((res) => {
        return checkCode(res)
      })
  },
  // 下载
  postFrontBlob(data) {
    const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    // userId='100010';
    return axios({
      responseType: 'blob',
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      data: data.param,
      dataType: 'json',
      headers: {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        firmId: firmId,
        'User-Id': userId,
        userId: userId,
        marketId: marketID,
        Language: Language,
        sessionStr: sessionStr,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase()
      },
      timeout: 120000
    })
      .then((response) => {
        return checkStatus(response)
      })
      .then((res) => {
        return checkCode(res)
      })
  },
  postFront1(data) {
    const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    // userId='100010';
    return axios({
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      data: data.param,
      dataType: 'json',
      headers: {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        firmId: firmId,
        'User-Id': userId,
        userId: userId,
        marketId: marketID,
        Language: Language,
        sessionStr: sessionStr,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase(),
        Info: { userStr: userId, ipType: '1', userCode: userId }
      },
      timeout: window.g.AXIOS_TIMEOUT
    })
      .then((response) => {
        return checkStatus(response)
      })
      .then((res) => {
        return checkCode(res)
      })
  },
  postFront2(data) { // 选货查所有的
    // const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    // userId='100010';
    return axios({
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      data: data.param,
      dataType: 'json',
      headers: {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        // firmId: firmId,
        'User-Id': userId,
        userId: userId,
        marketId: marketID,
        Language: Language,
        sessionStr: sessionStr,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase(),
        Info: { userStr: userId, ipType: '1', userCode: userId }
      },
      timeout: window.g.AXIOS_TIMEOUT
    })
      .then((response) => {
        return checkStatus(response)
      })
      .then((res) => {
        return checkCode(res)
      })
  },
  gPostMarket({ url, data }) {
    const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    const urlArr = window.location.href.split('/')
    let APP_URL_PATH_LOCAL = ''
    if (urlArr.length >= 3) {
      APP_URL_PATH_LOCAL = urlArr[0] + '//' + urlArr[2]
    } else {
      APP_URL_PATH_LOCAL = window.location.href
    }

    return axios({
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: window.g.APP_URL_PATH2 ? window.g.APP_URL_PATH2 : APP_URL_PATH_LOCAL,
      url,
      // url: window.g.APP_URL_PATH2,
      data: data,
      dataType: 'json',
      headers: {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        firmId: firmId,
        userId: userId,
        Language: Language,
        marketId: 0,
        // 'User-Id': userId,
        sessionStr: sessionStr,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase()
        // 'User-Id':firmId
      },
      timeout: 10000
    })
      .then((response) => {
        return checkStatus(response)
      })
      .then((res) => {
        return checkCode(res)
      })
  },
  // 挂牌服务Start
  gPost({ url, data }) {
    const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    const urlArr = window.location.href.split('/')
    let APP_URL_PATH_LOCAL = ''
    if (urlArr.length >= 3) {
      APP_URL_PATH_LOCAL = urlArr[0] + '//' + urlArr[2]
    } else {
      APP_URL_PATH_LOCAL = window.location.href
    }

    return axios({
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: window.g.APP_URL_PATH2 ? window.g.APP_URL_PATH2 : APP_URL_PATH_LOCAL,
      url,
      // url: window.g.APP_URL_PATH2,
      data: data,
      dataType: 'json',
      headers: {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        firmId: firmId,
        userId: userId,
        Language: Language,
        marketId: marketID,
        // 'User-Id': userId,
        sessionStr: sessionStr,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase()
        // 'User-Id':firmId
      },
      timeout: 10000
    })
      .then((response) => {
        return checkStatus(response)
      })
      .then((res) => {
        return checkCode(res)
      })
  },
  // 历史数据请求
  gPostHs({ url, data }) {
    const firmId = store.state.common.sessionInfo.firmId
    const userId = store.state.common.sessionInfo.userId
    const sessionStr = store.state.common.sessionInfo.sessionStr
    const urlArr = window.location.href.split('/')
    let APP_URL_PATH_LOCAL = ''
    if (urlArr.length >= 3) {
      APP_URL_PATH_LOCAL = urlArr[0] + '//' + urlArr[2]
    } else {
      APP_URL_PATH_LOCAL = window.location.href
    }

    return axios({
      method: 'post',
      baseURL: window.g.APP_URL_PATH2,
      url: window.g.APP_URL_PATH2 ? window.g.APP_URL_PATH2 : APP_URL_PATH_LOCAL,
      url,
      // url: window.g.APP_URL_PATH2,
      data: data,
      dataType: 'json',
      headers: {
        terminalType: localStorage.getItem('equipmentFlag_PC') || 4,
        firmId: firmId,
        userId: userId,
        Language: Language,
        marketId: marketID,
        // 'User-Id': userId,
        sessionStr: sessionStr,
        'Accept-Language':
          localStorage.lang || navigator.language.slice(-2).toLowerCase()
        // 'User-Id':firmId
      },
      timeout: 30000
    })
      .then((response) => {
        return checkStatus(response)
      })
      .then((res) => {
        return checkCode(res)
      })
  },
  // 挂牌服务End
  postFrontMarket(data) {
    // let firmId = store.state.common.sessionInfo.firmId;
    let sessionStr = store.state.common.sessionInfo.sessionStr;
    let userId = store.state.common.sessionInfo.userId;
    let marketId = JSON.parse(sessionStorage.getItem("marketId_w")) || 28;
    let headersObj = {};
    const Authorization =
      userId + "," + sessionStr + "," + data.url + "," + marketId;
    if (userId && sessionStr && userId != null && sessionStr != null) {
      headersObj = {
        // firmId: firmId,
        Authorization,
        sessionStr: sessionStr,
        userId: userId,
        marketId: marketId,
        terminalType: localStorage.getItem("equipmentFlag_PC") || 4
      };
    } else {
      headersObj = {
        terminalType: localStorage.getItem("equipmentFlag_PC") || 4
      };
    }
    // userId='100010';
    return axios({
      method: "post",
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      data: data.param,
      dataType: "json",
      headers: headersObj,
      timeout: window.g.AXIOS_TIMEOUT
    })
      .then(response => {
        return checkStatus(response);
      })
      .then(res => {
        return checkCode(res);
      });
  },
  postFrontMk0(data) {
    let marketId = 0;
    // let firmId = store.state.common.sessionInfo.firmId;
    let sessionStr = store.state.common.sessionInfo.sessionStr;
    let userId = store.state.common.sessionInfo.userId;
    let headersObj = {};
    const Authorization =
      userId + "," + sessionStr + "," + data.url + "," + marketId;
    if (userId && sessionStr && userId != null && sessionStr != null) {
      headersObj = {
        // firmId: firmId,
        Authorization,
        sessionStr: sessionStr,
        userId: userId,
        marketId: marketId,
        Language: "ZH",
        terminalType: localStorage.getItem("equipmentFlag_PC") || 4
      };
    } else {
      headersObj = {
        terminalType: localStorage.getItem("equipmentFlag_PC") || 4
      };
    }
    // userId='100010';
    return axios({
      method: "post",
      baseURL: window.g.APP_URL_PATH2,
      url: data.url,
      data: data.param,
      dataType: "json",
      headers: headersObj,
      timeout: window.g.AXIOS_TIMEOUT
    })
      .then(response => {
        return checkStatus(response);
      })
      .then(res => {
        return checkCode(res);
      });
  },
  postReport({
    url,
    param
  }) {
    const userId = store.state.common.sessionInfo.userId
    const sessionid = store.state.common.sessionInfo.userId
    const sessionstr = store.state.common.sessionInfo.sessionStr
    const sessionStr = store.state.common.sessionInfo.sessionStr
    const marketId = sessionStorage.getItem("marketId_w")!=null ? (JSON.parse(sessionStorage.getItem("marketId_w"))) : 28;
    const Authorization = userId + "," + sessionStr + "," + param.url + "," + marketId;
    if (sessionid != null && sessionid !== '') {
      param.userStr = sessionid
      param.sessionStr = sessionstr
      return axios({
        // 新增了一个返回值类型
        responseType: 'blob',
        method: 'post',
        baseURL: window.g.APP_URL_PATH2,
        url: url,
        data: param,
        dataType: 'json',
        headers: {
          Authorization,
          'sessionStr': sessionstr,
          'terminalType': localStorage.getItem('equipmentFlag_PC') || 4,
          'Accept-Language': localStorage.lang || navigator.language.slice(-2).toLowerCase(),
          'marketId': marketId,
          'UserId': sessionid,
          'firmId': store.state.common.sessionInfo.firmId
        },
        timeout: 120000
      })
        .then(response => {
          return checkStatus(response)
        })
        .then(res => {
          return checkCode(res)
        })
    } else {
      return axios({
        method: 'post',
        baseURL: window.g.APP_URL_PATH2,
        url: url,
        data: param,
        dataType: 'json',
        timeout: 120000
      })
        .then(response => {
          return checkStatus(response)
        })
        .then(res => {
          return checkCode(res)
        })
    }
  }
}
